<template>
  <b-modal
    :id="modalUUid"
    title="Verisoul Sessions"
    size="xl"
    scrollable
    hide-footer
  >
    <b-form-textarea
      ref="copyArea"
      :value="prettyPrintedJson"
      readonly
      no-resize
      rows="20"
      max-rows="30"
      spellcheck="false"
      class="text-monospace no-readonly-style"
    />
  </b-modal>
</template>

<script>
export default {
  name: 'VerisoulSessionsModal',
  props: {
    id: { type: [Number, String], required: true },
    data: { type: Array, default: () => [] }
  },
  computed: {
    modalUUid () {
      return `verisoulSessionsModal${this.id}`
    },
    prettyPrintedJson () {
      if (!this.data || this.data.length === 0) {
        return 'No Verisoul sessions available.'
      }
      return JSON.stringify(this.data, null, 2)
    }
  },
  methods: {
    showModal () {
      this.$bvModal.show(this.modalUUid)
    }
  }
}
</script>

<style scoped>
.no-readonly-style.form-control[readonly] {
  background-color: inherit !important;
  opacity: 1;
}
</style>
